import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { gsap } from 'gsap'
import { createPopper } from '@popperjs/core'

/**
 * Variables
 */
//const raycaster = new THREE.Raycaster();
const aabb = new THREE.Box3()
let controls
/**
 * Loaders
 */
const loadingBarElement = document.querySelector('.loading-bar')

let sceneReady = false

let idlerTimout

const loadingManager = new THREE.LoadingManager(
  // Loaded
  () => {
    // Wait a little
    window.setTimeout(() => {
      // Animate overlay
      gsap.to(overlayMaterial.uniforms.uAlpha, {
        duration: 3,
        value: 0,
        delay: 1,
      })

      // Update loadingBarElement
      loadingBarElement.classList.add('ended')
      loadingBarElement.style.transform = ''

      if (window.innerWidth > 479) {
        initTooltip()
      }
    }, 500)

    window.setTimeout(() => {
      sceneReady = true
      hotspot.forEach((item) => {
        item.classList.add('visible')
      })
    }, 2000)

    idlerTimout = window.setTimeout(() => {
      controls.autoRotate = true
    }, 3500)
  },

  // Progress
  (itemUrl, itemsLoaded, itemsTotal) => {
    // Calculate the progress and update the loadingBarElement
    const progressRatio = itemsLoaded / itemsTotal
    loadingBarElement.style.transform = `scaleX(${progressRatio})`
  }
)
const gltfLoader = new GLTFLoader(loadingManager)

/**
 * Base
 */

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Overlay
 */
const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)
const overlayMaterial = new THREE.ShaderMaterial({
  //wireframe: true,
  transparent: true,
  uniforms: {
    uAlpha: { value: 1 },
  },
  vertexShader: `
        void main()
        {
            gl_Position = vec4(position, 1.0);
        }
    `,
  fragmentShader: `
        uniform float uAlpha;

        void main()
        {
            gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
        }
    `,
})
const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
scene.add(overlay)

/**
 * Models
 */
gltfLoader.load('models/LF/Sorghum.glb', (gltf) => {
  gltf.scene.scale.set(1.5, 1.5, 1.5)
  gltf.scene.position.set(0, -45.5, 0)
  gltf.scene.rotation.y = Math.PI * 0.75
  scene.add(gltf.scene)
  aabb.setFromObject(gltf.scene)
})

/**
 * Points of interest
 */

const points = [
  {
    position: new THREE.Vector3(-6, 72.0, 1),
    element: document.querySelector('.point-0'),
  },
  {
    position: new THREE.Vector3(5, 20, -1),
    element: document.querySelector('.point-1'),
  },
  {
    position: new THREE.Vector3(-5, 5, -0.7),
    element: document.querySelector('.point-2'),
  },
  {
    position: new THREE.Vector3(-3, -50, 2),
    element: document.querySelector('.point-3'),
  },
]

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 1)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight('#ffffff', 3)
directionalLight.castShadow = true
directionalLight.shadow.camera.far = 15
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.normalBias = 0.05
directionalLight.position.set(0.25, 3, -0.25)
scene.add(directionalLight)

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
}

window.addEventListener('resize', () => {
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight
  const popperlength = Object.keys(popperInstances).length

  if (sizes.width <= 479) {
    if (popperlength > 0) {
      for (const key in popperInstances) {
        if (Object.hasOwnProperty.call(popperInstances, key)) {
          const element = popperInstances[key]
          element.destroy()
          delete popperInstances[key]
        }
      }
    }
  } else {
    if (popperlength <= 0) {
      initTooltip()
    }
  }

  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()

  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 1000)
camera.position.set(4, 0, -120)
scene.add(camera)

// Controls
controls = new OrbitControls(camera, canvas)
//controls.enablePan = false;
//controls.enableDamping = true;
controls.minPolarAngle = Math.PI / 2
controls.maxPolarAngle = Math.PI / 2

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  antialias: true,
  alpha: true,
})
renderer.physicallyCorrectLights = true
renderer.outputEncoding = THREE.sRGBEncoding
renderer.toneMapping = THREE.ReinhardToneMapping
renderer.toneMappingExposure = 3
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */

const hotspot = document.querySelectorAll('.point')
const exit = document.querySelectorAll('.exit')
const undo = document.querySelector('.undo')
const texts = document.querySelectorAll('.text')

undo.addEventListener('click', (event) => {
  event.stopPropagation()
  event.preventDefault()
  if (sizes.width <= 479) {
    hotspot.forEach((item) => {
      item.classList.add('visible')
    })
  }
  texts.forEach((item) => {
    item.classList.remove('clicked')
  })
  zoomback()
})

hotspot.forEach((item) => {
  item.addEventListener('click', (event) => {
    if (sizes.width <= 479) {
      hotspot.forEach((item) => {
        item.classList.remove('visible')
      })
    }

    texts.forEach((item) => {
      item.classList.remove('clicked')
    })

    if (item.classList.contains('point-0')) {
      item.classList.add('clicked')
      document.querySelector('.text-0').classList.add('clicked')
      if (sizes.width >= 532) {
        zoomin(-6, 58, 0, 3, 6)
      } else {
        zoomin(0, 58, 0, 3, 6)
      }
    } else if (item.classList.contains('point-1')) {
      item.classList.add('clicked')
      document.querySelector('.text-1').classList.add('clicked')
      if (sizes.width >= 532) {
        zoomin(1, 18, 0, 3, 9)
      } else if (sizes.width >= 479) {
        zoomin(6, 18, 0, 3, 9)
      } else {
        zoomin(0, 18, 0, 3, 9)
      }
    } else if (item.classList.contains('point-2')) {
      item.classList.add('clicked')
      document.querySelector('.text-2').classList.add('clicked')
      if (sizes.width >= 479) {
        zoomin(-20, -10, 0, 3, 4)
      } else {
        zoomin(0, 10, 0, 3, 4)
      }
    } else if (item.classList.contains('point-3')) {
      item.classList.add('clicked')
      document.querySelector('.text-3').classList.add('clicked')
      console.log(sizes.width)
      if (sizes.width >= 548) {
        zoomin(-5, -56, 0, 3, 7)
      } else if (sizes.width >= 479) {
        zoomin(-10, -56, 0, 3, 7)
      } else {
        zoomin(0, -56, 0, 3, 7)
      }
    }
  })
})

exit.forEach((item) => {
  item.addEventListener('click', (event) => {
    event.stopPropagation()
    event.preventDefault()
    if (sizes.width <= 479) {
      hotspot.forEach((element) => {
        element.classList.add('visible')
      })
    }
    const texts = document.querySelectorAll('.text')
    texts.forEach((item) => {
      item.classList.remove('clicked')
    })
    zoomback()
  })
})

function zoomin(posx, posy, posz, abs, zoom) {
  var center = aabb.getCenter(new THREE.Vector3())
  var size = aabb.getSize(new THREE.Vector3())

  gsap.to(controls.target, {
    duration: 1.4,
    x: center.x + posx,
    y: center.y + posy,
    z: center.z + posz,
    onUpdate: function () {
      controls.update()
    },
  })

  gsap.to(camera.position, {
    duration: 1.4,
    x: center.x,
    y: center.y,
    z: center.z - size.z * abs,
    onUpdate: function () {
      camera.lookAt(center)
      controls.update()
    },
  })
  gsap.to(camera, {
    duration: 1.4,
    zoom: zoom,
    onUpdate: function () {
      camera.updateProjectionMatrix()
    },
  })
}

function zoomback() {
  var center = aabb.getCenter(new THREE.Vector3())
  var size = aabb.getSize(new THREE.Vector3())
  gsap.to(controls.target, {
    duration: 1.4,
    x: center.x,
    y: center.y,
    z: center.z,
    onUpdate: function () {
      controls.update()
    },
  })

  gsap.to(camera.position, {
    duration: 1.4,
    x: center.x,
    y: center.y,
    z: center.z - size.z * 2,
    onUpdate: function () {
      camera.lookAt(center)
      controls.update()
    },
  })
  gsap.to(camera, {
    duration: 1.4,
    zoom: 1,
    onUpdate: function () {
      camera.updateProjectionMatrix()
    },
  })
}

/**
 * Popper Tooltip
 */
const tooltips = document.querySelectorAll('.point')
const popperInstances = {}

const initTooltip = () => {
  tooltips.forEach((tooltip) => {
    const button = tooltip
    //console.log (data[i].dataset.systemPath);
    const container = document.querySelector('.' + button.dataset.text)

    function show() {
      if (Object.keys(popperInstances).length > 0) {
        container.setAttribute('data-show', '')

        // We need to tell Popper to update the tooltip position
        // after we show the tooltip, otherwise it will be incorrect
        popperInstances[button.dataset.text].update()
      }
    }

    function hide() {
      container.removeAttribute('data-show')
    }

    const showEvents = ['mouseenter', 'focus']
    const hideEvents = ['mouseleave', 'blur']

    showEvents.forEach((event) => {
      button.addEventListener(event, show)
    })

    hideEvents.forEach((event) => {
      button.addEventListener(event, hide)
    })

    popperInstances[button.dataset.text] = createPopper(button, container, {
      placement: 'bottom-start',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [-12, 20],
          },
        },
        {
          name: 'preventOverflow',
          options: {
            mainAxis: true, // true by default
            padding: 5,
          },
        },
      ],
    })
  })
}

const tick = () => {
  // Update controls
  controls.update()
  //popperInstance.update();
  if (Object.keys(popperInstances).length > 0) {
    for (const key in popperInstances) {
      if (Object.hasOwnProperty.call(popperInstances, key)) {
        popperInstances[key].update()
      }
    }
  }

  // Update points only when the scene is ready
  if (sceneReady) {
    // Go through each point
    for (const point of points) {
      // Get 2D screen position
      const screenPosition = point.position.clone()
      screenPosition.project(camera)

      // // Set the raycaster
      // raycaster.setFromCamera(screenPosition, camera);
      // const intersects = raycaster.intersectObjects(scene.children, true);

      // // No intersect found
      // if (intersects.length === 0) {
      //   // Show
      //   point.element.classList.add("visible");
      // }

      // // Intersect found
      // else {
      //   // Get the distance of the intersection and the distance of the point
      //   const intersectionDistance = intersects[0].distance;
      //   const pointDistance = point.position.distanceTo(camera.position);

      //   // Intersection is close than the point
      //   if (intersectionDistance < pointDistance) {
      //     // Hide
      //     point.element.classList.remove("visible");
      //   }
      //   // Intersection is further than the point
      //   else {
      //     // Show
      //     point.element.classList.add("visible");
      //   }
      // }

      const translateX = screenPosition.x * sizes.width * 0.5
      const translateY = -screenPosition.y * sizes.height * 0.5
      point.element.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
    }
  }

  // Render
  renderer.render(scene, camera)

  // Call tick again on the next frame
  window.requestAnimationFrame(tick)
}

;(function () {
  tick()
  window.addEventListener('click', (event) => {
    clearTimeout(idlerTimout)
    controls.autoRotate = false
  })
})()
